var _linearGradient, _path, _circle, _circle2, _path2, _path3, _path4, _path5, _g, _g2, _g3, _linearGradient2, _rect, _rect2, _g4, _g5, _linearGradient3, _rect3, _path6, _rect4, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechSolutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-mobApps",
    viewBox: "0 0 420 443.7",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 221.895,
    x2: 201.895,
    y1: 415.564,
    y2: 143.564,
    gradientTransform: "matrix(1 0 0 -1 0 446)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#e7e7e7",
    className: "stopColorefdfed svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4f4f4",
    className: "stopColorfdf0f6 svgShape"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-background",
    fill: "#D99938",
    d: "M94.7,336.6C63.3,294.6-3,277.8,4,216.1c5-44.8,38.4-76.7,71.7-93.2 c50.6-25,67.7-78.6,114.7-104.5C240.6-9.3,311,4.7,358.4,41.6c50.5,39.3,67.4,96,53.3,154.4c-7.1,29.1-23.2,53.4-33.5,80.8 c-11.5,30.5-21.5,43.8-32.1,74.4c-19.1,55.2-73,105.5-139.5,84.7C149.9,418.4,128.1,381.3,94.7,336.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M365.7,117.3v2.6H363c-0.9,0-1.6,0.7-1.6,1.6v0.1c0,0.9,0.7,1.6,1.6,1.6h2.6v2.6 c0,0.9,0.7,1.6,1.6,1.6h0.1c0.9,0,1.6-0.7,1.6-1.6v-2.6h2.6c0.9,0,1.6-0.7,1.6-1.6v-0.1c0-0.9-0.7-1.6-1.6-1.6h-2.6v-2.6 c0-0.9-0.7-1.6-1.6-1.6h-0.1C366.4,115.6,365.7,116.4,365.7,117.3z",
    style: {
      transformOrigin: "367.25px 121.546px"
    },
    className: "star star-1 origin-center colorfff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "M237.9,386.9v3.9H234c-1.3,0-2.4,1.1-2.4,2.4v0.1c0,1.3,1.1,2.4,2.4,2.4h3.9v3.9 c0,1.3,1.1,2.4,2.4,2.4h0.1c1.3,0,2.4-1.1,2.4-2.4v-3.9h3.9c1.3,0,2.4-1.1,2.4-2.4v-0.1c0-1.3-1.1-2.4-2.4-2.4h-3.9v-3.9 c0-1.3-1.1-2.4-2.4-2.4h-0.1C239,384.4,237.9,385.5,237.9,386.9z",
    style: {
      transformOrigin: "240.35px 393.247px"
    },
    className: "star star-2 origin-center colorefdfed svgShape"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 45.6,
    r: 4.7,
    fill: "#ffffff",
    className: "colorfff svgShape"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 138.6,
    r: 4.7,
    fill: "#e7e7e7",
    className: "colorefdfed svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      transformOrigin: "109.137px 223.25px"
    },
    className: "gear origin-center color000 svgShape",
    fill: "#000000"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#684127",
    d: "M166,216.1l-1-5.2c-0.1-0.4-0.4-0.6-0.8-0.5l-4.2,0.8c-0.9-3.8-2.2-7.5-3.9-10.9     l3.8-2.2c0.3-0.2,0.4-0.6,0.2-0.9l-2.7-4.6c-0.2-0.3-0.6-0.4-0.9-0.2l-3.7,2.2c-2.1-3.2-4.6-6.2-7.4-8.9l2.8-3.4     c0.2-0.3,0.2-0.7-0.1-0.9L144,178c-0.3-0.2-0.7-0.2-0.9,0.1l-2.8,3.3c-3.1-2.3-6.4-4.3-10-5.9l1.5-4.1c0.1-0.3-0.1-0.7-0.4-0.8     l-5-1.8c-0.3-0.1-0.7,0.1-0.8,0.4l-1.4,4c-3.7-1.1-7.5-1.8-11.4-2v-4.4c0-0.4-0.3-0.7-0.7-0.7h-5.3c-0.4,0-0.7,0.3-0.7,0.7v4.3     c-3.9,0.2-7.8,0.9-11.4,1.9l-1.5-4.1c-0.1-0.3-0.5-0.5-0.9-0.4l-5,1.9c-0.3,0.1-0.5,0.5-0.4,0.8l1.5,4c-3.6,1.5-6.9,3.5-10,5.8     l-2.9-3.4c-0.2-0.3-0.7-0.3-0.9-0.1l-4,3.4c-0.3,0.2-0.3,0.7-0.1,0.9l2.8,3.3c-2.8,2.7-5.4,5.6-7.5,8.8l-3.8-2.2     c-0.3-0.2-0.7-0.1-0.9,0.3l-2.6,4.6c-0.2,0.3-0.1,0.7,0.2,0.9l3.8,2.1c-1.7,3.4-3.1,7.1-4,10.9l-4.4-0.7c-0.4-0.1-0.7,0.2-0.8,0.5     l-0.9,5.2c-0.1,0.4,0.2,0.7,0.5,0.8l4.3,0.7c-0.2,2.1-0.4,4.3-0.4,6.5c0,1.7,0.1,3.4,0.3,5.1l-4.3,0.8c-0.4,0.1-0.6,0.4-0.5,0.8     l1,5.2c0.1,0.4,0.4,0.6,0.8,0.5l4.2-0.8c0.9,3.8,2.2,7.5,3.9,10.9l-3.8,2.2c-0.3,0.2-0.4,0.6-0.2,0.9l2.7,4.6     c0.2,0.3,0.6,0.4,0.9,0.2l3.7-2.2c2.1,3.2,4.6,6.2,7.4,8.9l-2.8,3.4c-0.2,0.3-0.2,0.7,0.1,0.9l4.1,3.4c0.3,0.2,0.7,0.2,0.9-0.1     L78,265c3.1,2.3,6.4,4.3,10,5.9l-1.5,4.2c-0.1,0.3,0.1,0.7,0.4,0.8l5,1.8c0.3,0.1,0.7-0.1,0.8-0.4l1.4-4c3.6,1.1,7.5,1.8,11.4,2     v4.4c0,0.4,0.3,0.7,0.7,0.7h5.3c0.4,0,0.7-0.3,0.7-0.7v-4.4c3.9-0.2,7.8-0.9,11.4-1.9l1.5,4.1c0.1,0.3,0.5,0.5,0.8,0.4l5-1.9     c0.3-0.1,0.5-0.5,0.4-0.8l-1.5-4c3.6-1.5,6.9-3.5,10-5.8l2.9,3.4c0.2,0.3,0.7,0.3,0.9,0.1l4-3.4c0.3-0.2,0.3-0.7,0.1-0.9l-2.8-3.3     c2.8-2.7,5.4-5.6,7.5-8.8l3.8,2.2c0.3,0.2,0.7,0.1,0.9-0.2l2.6-4.6c0.2-0.3,0.1-0.7-0.3-0.9l-3.8-2.1c1.7-3.4,3.1-7.1,4-10.9     l4.4,0.7c0.4,0.1,0.7-0.2,0.8-0.5l0.9-5.2c0.1-0.4-0.2-0.7-0.5-0.8l-4.3-0.7c0.2-2.1,0.4-4.3,0.4-6.5c0-1.7-0.1-3.4-0.3-5.1     l4.3-0.8C165.8,216.8,166,216.5,166,216.1z M109.3,236.1c-7.2,0.1-13-5.7-13.1-12.9s5.7-13,12.9-13.1c7.2,0,13,5.7,13.1,12.9     C122.2,230.2,116.4,236.1,109.3,236.1z",
    className: "color582768 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M109.1,252.3c-13.6,0-25.2-9.2-28.4-22.4c-1.8-7.6-0.6-15.4,3.5-22.1         c4.1-6.6,10.5-11.3,18.1-13.1c2.2-0.5,4.5-0.8,6.8-0.8c13.6,0,25.2,9.2,28.4,22.4c1.8,7.6,0.6,15.4-3.5,22.1         c-4.1,6.6-10.5,11.3-18.1,13.1C113.7,252.1,111.4,252.3,109.1,252.3L109.1,252.3z M109.2,195.7c-2.1,0-4.3,0.3-6.4,0.8         c-7.1,1.7-13.2,6.1-17,12.3c-3.9,6.3-5,13.6-3.3,20.8c3,12.4,14,21.1,26.7,21.1c2.1,0,4.3-0.3,6.4-0.8c7.1-1.7,13.2-6.1,17-12.3         c3.9-6.3,5-13.6,3.3-20.8C132.9,204.3,121.9,195.7,109.2,195.7L109.2,195.7z",
    className: "colorfff svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7d4823",
    d: "M109.1,258.9c-16.6,0-30.9-11.3-34.7-27.4c-2.2-9.3-0.7-18.9,4.3-27         s12.9-13.8,22.1-16c2.7-0.6,5.5-1,8.3-1c16.6,0,30.9,11.3,34.7,27.4c4.6,19.2-7.3,38.4-26.5,43         C114.7,258.5,111.9,258.9,109.1,258.9L109.1,258.9z M109.2,190.8c-2.5,0-5.1,0.3-7.5,0.9c-8.4,2-15.5,7.2-20.1,14.5         c-4.5,7.4-5.9,16-3.9,24.4c3.5,14.6,16.4,24.9,31.4,24.9c2.5,0,5-0.3,7.5-0.9c17.3-4.1,28.1-21.6,24-39         C137.1,201,124.2,190.8,109.2,190.8L109.2,190.8z",
    className: "color7d2360 svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#674026",
    d: "M111.2,231.9c-4.8,1.1-9.7-1.8-10.8-6.6c-1.1-4.8,1.8-9.7,6.6-10.8     c4.8-1.2,9.7,1.8,10.8,6.6C119,225.9,116.1,230.7,111.2,231.9z",
    className: "color5e2667 svgShape"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "phone color000 svgShape",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9e5421",
    d: "M230.2,334.9c0.1,8-6.3,14.6-14.3,14.7l-86.6,1.3c-8,0.1-14.6-6.3-14.7-14.3         l-3.1-205.2c-0.1-8,6.3-14.6,14.3-14.7l86.6-1.3c8-0.1,14.6,6.3,14.7,14.3L230.2,334.9z",
    className: "color9e2159 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e5421",
    d: "M131.5,348.7c-8,0.1-14.6-6.3-14.7-14.3l-3-200.8c-0.1-8,6.3-14.6,14.3-14.7         l82.2-1.2c8-0.1,14.6,6.3,14.7,14.3l3,200.8c0.1,8-6.3,14.6-14.3,14.7L131.5,348.7z",
    className: "color9e2159 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M155.6 130.6c0 1.1-.8 2-1.9 2-1.1 0-2-.8-2-1.9 0-1.1.9-2 1.9-2C154.7 128.6 155.5 129.5 155.6 130.6zM170.3 123.6c0 .7-.5 1.3-1.2 1.3s-1.3-.5-1.3-1.2.5-1.3 1.2-1.3C169.7 122.3 170.3 122.9 170.3 123.6zM176.8 130.1c0 .5-.4.9-.9.9l-13.4.2c-.5 0-.9-.4-.9-.9l0 0c0-.5.4-.9.9-.9l13.4-.2C176.4 129.1 176.8 129.6 176.8 130.1L176.8 130.1zM180.4 337.7c0 .9-.7 1.7-1.7 1.7l-12.3.2c-.9 0-1.7-.7-1.7-1.6v-3.4c0-.9.7-1.7 1.7-1.7l12.3-.2c.9 0 1.7.7 1.7 1.7V337.7z",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -357.391,
    x2: -208.277,
    y1: -111.723,
    y2: -111.723,
    gradientTransform: "scale(1 -1) rotate(-15.927 -488.511 -1793.469)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#e7e7e7",
    className: "stopColorefdfed svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4f4f4",
    className: "stopColorfdf0f6 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#b)",
    points: "222.8 322 121.3 323.5 118.7 143.4 220.1 141.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9e5421",
    points: "119.5 201.3 120.4 259.5 190.1 142.3 154.3 142.9",
    enableBackground: "new",
    opacity: 0.1,
    className: "color9e2159 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9e5421",
    points: "120.9 291.7 209.9 142 196.3 142.2 120.5 269.6",
    enableBackground: "new",
    opacity: 0.1,
    className: "color9e2159 svgShape"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "pen color000 svgShape",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#f6f6f6",
    points: "140.4 89.9 115.1 82.2 140.4 74.5",
    className: "colorfdeff5 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#975121",
    d: "M356.1,76.7c-0.9-0.9-1.9-1.5-3-1.8c0.3,0.8,0.4,1.6,0.4,2.4c0,2-0.8,3.9-2.3,5.4     s-3.5,2.3-5.4,2.3H341v4.8h9.6c2,0,3.9-0.8,5.4-2.3s2.3-3.5,2.3-5.4C358.4,80.2,357.6,78.2,356.1,76.7z",
    className: "color97215b svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 140.4,
    x2: 332.2,
    y1: 363.8,
    y2: 363.8,
    gradientTransform: "matrix(1 0 0 -1 0 446)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#a65822",
    className: "stopColora62257 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#864c24",
    className: "stopColor86245e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#684127",
    className: "stopColor582768 svgShape"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 191.8,
    height: 15.4,
    x: 140.4,
    y: 74.5,
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f6f6f6",
    points: "115.1 82.2 140.4 89.9 140.4 85",
    className: "colorfdeff5 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#744524",
    points: "125 85.2 115.1 82.2 125 83.3",
    className: "color742462 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.9,
    height: 4.8,
    x: 332.2,
    y: 85,
    fill: "#f6f6f6",
    className: "colorfdeff5 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 133.799,
    x2: 227.743,
    y1: 358.6,
    y2: 358.6,
    gradientTransform: "matrix(1 0 0 -1 0 446)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#a65822",
    className: "stopColora62257 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#864c24",
    className: "stopColor86245e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#684127",
    className: "stopColor582768 svgShape"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 191.8,
    height: 4.8,
    x: 140.4,
    y: 85,
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#744524",
    points: "125 85.2 115.1 82.2 125 79.2",
    className: "color742462 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.9,
    height: 15.4,
    x: 332.2,
    y: 74.5,
    fill: "#f6f6f6",
    className: "colorfdeff5 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c36a2d",
    d: "M350.7,89.9c2,0,3.9-0.8,5.4-2.3s2.3-3.5,2.3-5.4l0,0c0-2-0.8-3.9-2.3-5.4     s-3.5-2.3-5.4-2.3h-9.6v15.4C341.1,89.9,350.7,89.9,350.7,89.9z",
    className: "colora62257 svgShape"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "ruler hover color000 svgShape",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 281.9,
    x2: 315.244,
    y1: 255.35,
    y2: 255.35,
    gradientTransform: "matrix(1 0 0 -1 0 446)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#dbba6b",
    className: "stopColordb6b86 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#dcbb6d",
    className: "stopColordc6d87 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eadca6",
    className: "stopColorf7a6a5 svgShape"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 33.3,
    height: 232.3,
    x: 281.9,
    y: 74.5,
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.8,
    height: 1.7,
    x: 281.9,
    y: 298.3,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.8,
    height: 1.7,
    x: 281.9,
    y: 283,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.8,
    height: 1.7,
    x: 281.9,
    y: 267.6,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.8,
    height: 1.7,
    x: 281.9,
    y: 252.2,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.8,
    height: 1.7,
    x: 281.9,
    y: 236.9,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.8,
    height: 1.7,
    x: 281.9,
    y: 221.5,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.8,
    height: 1.7,
    x: 281.9,
    y: 206.1,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.8,
    height: 1.7,
    x: 281.9,
    y: 190.8,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.8,
    height: 1.7,
    x: 281.9,
    y: 175.4,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.8,
    height: 1.7,
    x: 281.9,
    y: 160,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.8,
    height: 1.7,
    x: 281.9,
    y: 144.7,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.4,
    height: 1.7,
    x: 281.9,
    y: 121.6,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.6,
    height: 1.7,
    x: 281.9,
    y: 106.2,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.6,
    height: 1.7,
    x: 281.9,
    y: 90.9,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.6,
    height: 1.7,
    x: 281.9,
    y: 290.7,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.6,
    height: 1.7,
    x: 281.9,
    y: 275.3,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.6,
    height: 1.7,
    x: 281.9,
    y: 259.9,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.6,
    height: 1.7,
    x: 281.9,
    y: 244.5,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.6,
    height: 1.7,
    x: 281.9,
    y: 229.2,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.6,
    height: 1.7,
    x: 281.9,
    y: 213.8,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.6,
    height: 1.7,
    x: 281.9,
    y: 198.4,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.6,
    height: 1.7,
    x: 281.9,
    y: 183.1,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.6,
    height: 1.7,
    x: 281.9,
    y: 167.7,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.6,
    height: 1.7,
    x: 281.9,
    y: 152.3,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.6,
    height: 1.7,
    x: 281.9,
    y: 137,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.8,
    height: 1.7,
    x: 281.9,
    y: 129.3,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.8,
    height: 1.7,
    x: 281.9,
    y: 113.9,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.8,
    height: 1.7,
    x: 281.9,
    y: 98.5,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.8,
    height: 1.7,
    x: 281.9,
    y: 83.2,
    fill: "#ffffff",
    className: "colorfff svgShape"
  })))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 300.9,
    x2: 300.9,
    y1: 159.461,
    y2: 260.75,
    gradientTransform: "matrix(1 0 0 -1 0 446)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#a65822",
    className: "stopColora62257 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#864c24",
    className: "stopColor86245e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#684127",
    className: "stopColor582768 svgShape"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 156.2,
    x: 240.4,
    y: 174.9,
    fill: "url(#f)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 14.8,
    x: 240.4,
    y: 160.1,
    fill: "#9e5421",
    className: "color9e2159 svgShape"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "login color000 svgShape",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 221.405,
    x2: 226.87,
    y1: 119.202,
    y2: 182.05,
    gradientTransform: "matrix(1 0 0 -1 0 446)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#dbba6b",
    className: "stopColordb6b86 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#dcbb6d",
    className: "stopColordc6d87 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eadca6",
    className: "stopColorf7a6a5 svgShape"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 77.8,
    height: 51,
    x: 184.2,
    y: 281.8,
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77.8,
    height: 8.7,
    x: 184.2,
    y: 273.1,
    fill: "#684127",
    className: "color582768 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.4,
    height: 2.2,
    x: 216.4,
    y: 319.5,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.7,
    height: 8.7,
    x: 238.9,
    y: 289.7,
    fill: "#c36a2d",
    fillRule: "evenodd",
    clipRule: "evenodd",
    className: "colora62257 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M244.5 293.2c0 .8-.6 1.5-1.3 1.5s-1.3-.7-1.3-1.5.6-1.5 1.3-1.5S244.5 292.4 244.5 293.2zM243.9 295.1c-.2.1-.4.2-.7.2-.2 0-.5-.1-.7-.2-.9.2-1.6.7-1.7 1.2h4.8C245.5 295.7 244.8 295.2 243.9 295.1z",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40.3,
    height: 8.7,
    x: 198.6,
    y: 289.7,
    fill: "#ffffff",
    fillRule: "evenodd",
    clipRule: "evenodd",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.5,
    height: 2.2,
    x: 206.5,
    y: 292.9,
    fill: "#684127",
    className: "color582768 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.7,
    height: 8.7,
    x: 238.9,
    y: 301.4,
    fill: "#c36a2d",
    fillRule: "evenodd",
    clipRule: "evenodd",
    className: "colora62257 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M244.4,305.4v-0.7c0-0.7-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2v0.7h-0.4v2.7h3.3v-2.7     H244.4z M244,305.4h-1.6v-0.7c0-0.5,0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8V305.4z",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40.3,
    height: 8.7,
    x: 198.6,
    y: 301.4,
    fill: "#ffffff",
    fillRule: "evenodd",
    clipRule: "evenodd",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#684127",
    d: "M207.6 304.7c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1 1.1-.5 1.1-1.1C208.7 305.2 208.2 304.7 207.6 304.7zM212 304.7c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1 1.1-.5 1.1-1.1S212.7 304.7 212 304.7zM216.5 304.7c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1 1.1-.5 1.1-1.1S217.1 304.7 216.5 304.7zM221 304.7c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1 1.1-.5 1.1-1.1S221.6 304.7 221 304.7zM225.4 304.7c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1 1.1-.5 1.1-1.1S226 304.7 225.4 304.7zM229.9 304.7c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1 1.1-.5 1.1-1.1S230.5 304.7 229.9 304.7z",
    className: "color582768 svgShape"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "hook hover color000 svgShape",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#955123",
    d: "M125.4,123.2c-0.3,0-0.6-0.1-0.8-0.4c-0.4-0.5-0.3-1.1,0.2-1.5l44.4-34.7     c0.9-0.7,1.9-1.1,3-1.1c1.1-0.1,2.2,0.2,3.1,0.7l41.6,23.6c0.5,0.3,0.7,0.9,0.4,1.4s-0.9,0.7-1.4,0.4L174.3,88     c-0.6-0.3-1.3-0.5-1.9-0.4c-0.7,0-1.3,0.3-1.9,0.7L126,123C125.8,123.2,125.6,123.2,125.4,123.2z",
    className: "color95235b svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 90.9,
    height: 19.6,
    x: 116.4,
    y: 116.4,
    fill: "#f1d593",
    transform: "rotate(-7.193 161.853 126.194)",
    className: "colorf1939b svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 85.3,
    height: 11.9,
    x: 119.2,
    y: 120.2,
    fill: "#ffffff",
    transform: "rotate(-7.193 161.848 126.202)",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.1,
    height: 2.5,
    x: 123.5,
    y: 128.3,
    fill: "#f1d593",
    transform: "rotate(-7.18 136.053 129.553)",
    className: "colorf1939b svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.6,
    height: 19.6,
    x: 206.9,
    y: 109.4,
    fill: "#f1d593",
    transform: "rotate(-7.187 217.195 119.2)",
    className: "colorf1939b svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M222.5,122.3l-2.4-1.8c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0.1-0.2,0.1l-0.1,0.1     l-0.7-0.5c0.4-0.7,0.7-1.6,0.5-2.5c-0.3-2.1-2.2-3.6-4.3-3.3c-2.1,0.3-3.6,2.2-3.3,4.3c0.3,2.1,2.2,3.6,4.3,3.3     c0.9-0.1,1.7-0.5,2.3-1.1l0.7,0.5l-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2s0.1,0.2,0.1,0.2l2.4,1.8c0.2,0.1,0.4,0.2,0.6,0.2     c0.2,0,0.4-0.1,0.6-0.3c0.1-0.2,0.2-0.4,0.2-0.6C222.8,122.6,222.7,122.4,222.5,122.3z M216.1,121.2c-1.7,0.2-3.3-1-3.6-2.8     c-0.2-1.7,1-3.3,2.8-3.5c1.7-0.2,3.3,1,3.6,2.8C219.1,119.4,217.8,121,216.1,121.2z",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2d694",
    d: "M172.1,91.3c-7.2,0-13-5.8-13-13c0-1,0.8-1.9,1.9-1.9c1,0,1.8,0.8,1.8,1.9     c0,5.1,4.2,9.3,9.3,9.3s9.3-4.2,9.3-9.3s-4.2-9.3-9.3-9.3c-1,0-1.9-0.8-1.9-1.9V62c0-1,0.8-1.9,1.9-1.9c1,0,1.9,0.8,1.9,1.9v3.5     c6.3,0.9,11.1,6.3,11.1,12.8C185.1,85.5,179.2,91.3,172.1,91.3z",
    className: "colorf2949c svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#955123",
    d: "M172.1,87.6c-0.6,0.1-1.2,0.3-1.7,0.7l-2.8,2.2c-0.7-0.3-1.4-0.6-2.1-1l3.2-2.5     C169.8,87.4,170.9,87.6,172.1,87.6z",
    className: "color95235b svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#824a24",
    d: "M172.1,63.9c-2.8,0-5-2.3-5-5c0-2.8,2.3-5,5-5c2.8,0,5,2.3,5,5     C177.1,61.6,174.9,63.9,172.1,63.9z M172.1,57.5c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3     C173.4,58.1,172.8,57.5,172.1,57.5z",
    className: "color82245e svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2d694",
    d: "M172.1,59.9c-0.6,0-1-0.2-1-0.5v-26c2,0,0,0,2,0v26     C173.1,59.6,172.7,59.9,172.1,59.9z",
    className: "colorf2949c svgShape"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 291.5,
    x2: 367.3,
    y1: 138.6,
    y2: 138.6,
    gradientTransform: "matrix(1 0 0 -1 0 446)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#e7e7e7",
    className: "stopColorefdfed svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4f4f4",
    className: "stopColorfdf0f6 svgShape"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 75.8,
    height: 47.4,
    x: 291.5,
    y: 283.7,
    fill: "url(#h)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "play-btn hover color000 svgShape",
    fill: "#000000"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#684127",
    d: "M329.5,318.5c-6.1,0-11-5-11-11c0-6.1,5-11,11-11c6.1,0,11,5,11,11     S335.5,318.5,329.5,318.5z M329.5,297.1c-5.7,0-10.3,4.6-10.3,10.3s4.6,10.3,10.3,10.3c5.7,0,10.3-4.6,10.3-10.3     S335.2,297.1,329.5,297.1z",
    className: "color582768 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#684127",
    points: "327.4 303.9 333.6 307.4 327.4 311",
    style: {
      transformOrigin: "330.5px 307.45px"
    },
    className: "origin-center hover color582768 svgShape"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 75.8,
    height: 14.2,
    x: 291.5,
    y: 331.1,
    fill: "#684127",
    className: "color582768 svgShape"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "play-bar color000 svgShape",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#f1d593",
    points: "223 187.1 208.2 187.1 208.2 201.9 223 201.9 292 201.9 292 187.1",
    className: "colorf1939b svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56.8,
    height: 1.5,
    x: 229.1,
    y: 193.7,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.8,
    height: 14.8,
    x: 292,
    y: 187.1,
    fill: "#e0c074",
    className: "colore0748b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "213 191.5 218.1 194.5 213 197.4",
    className: "play-bar--play colorfff svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    className: "play-bar--pause color000 svgShape",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 6.5,
    x: 216.9,
    y: 191.2,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 6.5,
    x: 213.7,
    y: 191.2,
    fill: "#ffffff",
    className: "colorfff svgShape"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 3.4,
    x: 297,
    y: 192.8,
    fill: "#ffffff",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "302 198.2 299.3 196.2 299.3 192.8 302 190.8",
    className: "colorfff svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.6,
    cy: 194.5,
    r: 3,
    fill: "#9e5421",
    className: "color9e2159 svgShape"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 39.6,
    height: 3.4,
    style: {
      transformOrigin: "261.1px 242.3px"
    },
    x: 261.1,
    y: 242.3,
    fill: "#e2c275",
    className: "line-b hover origin-left colorf6a0a2 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 74.7,
    height: 3.4,
    style: {
      transformOrigin: "261.1px 231.6px"
    },
    x: 261.1,
    y: 231.6,
    fill: "#e2c275",
    className: "line-m hover origin-left colorf6a0a2 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 74.7,
    height: 3.4,
    style: {
      transformOrigin: "261.1px 220.7px"
    },
    x: 261.1,
    y: 220.7,
    fill: "#e2c275",
    className: "line-t hover origin-left colorf6a0a2 svgShape"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechSolutions);
export default __webpack_public_path__ + "static/media/tech_solutions.c3b6ad79.svg";
export { ForwardRef as ReactComponent };